import errorIllustration from 'src/icons/error-illustration.svg';

const ErrorState = () => {
    return (
        <div className="w-screen h-screen flex flex-col justify-center items-center">
            <img src={errorIllustration} alt="An unexpected error has occured" width={300} />
            <span className="text-lg mt-10 text-center">An unexpected error has occured, please try again...</span>
        </div>
    );
};

export default ErrorState;
